// 获取授权token
export const GET_MESSAGE_TOKEN = 'GET_MESSAGE_TOKEN';
// 设置授权token
export const SET_MESSAGE_TOKEN = 'SET_MESSAGE_TOKEN';
// 设置消息列表
export const SET_MESSAGE_LIST = 'SET_MESSAGE_LIST';
// 获取消息列表
export const GET_MESSAGE_LIST = 'GET_MESSAGE_LIST';
// 获取单条消息信息
export const GET_MESSAGE_DETAILS = 'GET_MESSAGE_DETAILS';
// 改变已读状态
export const SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS';
// 添加消息
export const ADD_MESSAGE = 'ADD_MESSAGE';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_message.js